import MapLibreGL from "maplibre-gl";

import { parseMouseEvent } from "./utils";

enum DotNetMethod {
    HandleClickAsync = "HandleClickAsync",
    HandleMouseEnterAsync = "HandleMouseEnterAsync",
    HandleMouseLeaveAsync = "HandleMouseLeaveAsync",
    HandleDragStartAsync = "HandleDragStartAsync",
    HandleDragEndAsync = "HandleDragEndAsync",
    HandleDragAsync = "HandleDragAsync",
}

type Entry = {
    marker: MapLibreGL.Marker;
};

const registry = new Map<any, Entry>();

function initialize(
    dotNetHelper: any,
    map: MapLibreGL.Map,
    options: MapLibreGL.MarkerOptions,
    lnglat: MapLibreGL.LngLat
) {
    const marker = new MapLibreGL.Marker(options)
        .setLngLat(lnglat)
        .addTo(map);

    const handleClick = (e: MouseEvent) => {
        dotNetHelper.invokeMethodAsync(DotNetMethod.HandleClickAsync, parseMouseEvent(e));
    }

    const handleMouseEnter = (e: MouseEvent) => {
        dotNetHelper.invokeMethodAsync(DotNetMethod.HandleMouseEnterAsync, parseMouseEvent(e));
    }

    const handleMouseLeave = (e: MouseEvent) => {
        dotNetHelper.invokeMethodAsync(DotNetMethod.HandleMouseLeaveAsync, parseMouseEvent(e));
    }

    const handleDragStart = () => {
        const lngLat = marker.getLngLat();
        dotNetHelper.invokeMethodAsync(DotNetMethod.HandleDragStartAsync, lngLat);
    }

    const handleDragEnd = () => {
        const lngLat = marker.getLngLat();
        dotNetHelper.invokeMethodAsync(DotNetMethod.HandleDragEndAsync, lngLat);
    }

    const handleDrag = () => {
        const lngLat = marker.getLngLat();
        dotNetHelper.invokeMethodAsync(DotNetMethod.HandleDragAsync, lngLat);
    }

    const markerEl = marker.getElement();
    markerEl.addEventListener("click", handleClick);
    markerEl.addEventListener("mouseenter", handleMouseEnter);
    markerEl.addEventListener("mouseleave", handleMouseLeave);

    marker.on("dragstart", handleDragStart);
    marker.on("dragend", handleDragEnd);
    marker.on("drag", handleDrag);

    registry.set(dotNetHelper, {
        marker
    });

    return marker;
}

function destroy(dotNetHelper: any) {
    const entry = registry.get(dotNetHelper);
    if (!entry) return;

    const { marker } = entry;

    // This effectively removes any event listeners attached to the marker.
    marker.remove();

    dotNetHelper.dispose();

    registry.delete(dotNetHelper);
}

export default {
    initialize,
    destroy
}